<template>
  <div>
    <transition name="fade">
      <v-overlay :z-index="202 + layer * 2 - 1" v-if="value"></v-overlay>
    </transition>
    <v-dialog persistent :value="value" :max-width="maxWidth" hide-overlay>
      <v-card class="unmarkable">
        <v-card-title v-if="dialogTitle">
          <v-icon v-if="!!icon">
            {{ icon }}
          </v-icon>
          &nbsp;
          {{ dialogTitle }}
        </v-card-title>
        <v-divider v-if="dialogTitle" />
        <v-card-text v-if="dialogText">{{ dialogText }}</v-card-text>
        <v-divider v-if="dialogText" />
        <v-card-actions>
          <v-spacer />
          <v-btn color="error" text @click="onCancelClick">
            {{ cancelText }}
          </v-btn>
          <v-btn color="secondary darken-1" text @click="onOkClick">{{
            okText
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "OkCancelDialogFromAction",

  data: function() {
    return {
      value: false
    };
  },

  computed: mapState("okCancelDialog", [
    "showDialog",
    "dialogTitle",
    "dialogText",
    "okText",
    "cancelText",
    "maxWidth",
    "onOk",
    "onCancel",
    "icon",
    "layer"
  ]),

  watch: {
    showDialog(newValue) {
      this.value = newValue;
    }
  },

  methods: {
    onOkClick() {
      this.onOk();
      this.$store.state.okCancelDialog.resolve(true);
    },
    onCancelClick() {
      this.onCancel();
      this.$store.state.okCancelDialog.resolve(false);
    }
  }
};
</script>

<style scoped></style>
